import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { AppVersion } from '@ionic-native/app-version';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

@Component({
  selector: 'page-sobre',
  templateUrl: 'sobre.html',
})
export class SobrePage {

	version:any = 0;

	constructor(public navCtrl: NavController, public navParams: NavParams, private appVersion: AppVersion, private _auth: AuthProvider)
	{
		this.getVersion();
	}

	// Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
    }

	async getVersion()
	{
		this.version = await this.appVersion.getVersionNumber();
		// console.log(this.version);
	}

}



// WEBPACK FOOTER //
// ./src/pages/sobre/sobre.ts